"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { useElements } from '../element/useElements.mjs';

function useAppEventTypes(query) {
  const { ...rest } = useElements("app-event-types", query);
  return {
    appEventTypes: rest.items,
    ...rest
  };
}

export { useAppEventTypes };
